import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router";
import { Provider as ReduxProvider } from "react-redux";
import { Toaster } from "sonner";

import { router } from "@/App";
import { store } from "@/store";
import { initSentry } from "@/lib/sentry";

import "@/styles/globals.css";

initSentry();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element in index.html");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <RouterProvider router={router} />
      <Toaster
        position="bottom-right"
        richColors
        closeButton
        toastOptions={{ duration: 6_000 }}
      />
    </ReduxProvider>
  </React.StrictMode>,
);
